// Common default properties shared across all interactive components
// These are internal styling properties that should be consistent

export const COMMON_EDGE_DEFAULTS = {
  // Edge stroke properties for interactive handles/nodes
  edgeStroke: {
    color: "#000000",
    dash: "Solid",
    width: 1,
    opacity: 1,
  },

  // Edge fill color for interactive handles/nodes
  edgeFill: "#FFFFFF",

  // Node radius for interactive handles/circles
  r: 5,
};

// Default colors for appearance fallbacks
export const DEFAULT_APPEARANCE_COLORS = {
  // Default stroke color for indicators and interactive objects
  defaultStrokeColor: "#FF0000",

  // Default fill color for interactive objects
  defaultFillColor: "#FF0000",

  // Default opacity for fills
  defaultFillOpacity: 0.1,

  // Default stroke width
  defaultStrokeWidth: 2,

  // Default stroke opacity
  defaultStrokeOpacity: 1,

  // Default dash style
  defaultStrokeDash: "Solid",
};

// Additional edge defaults for specific components that need extra properties
export const EXTENDED_EDGE_DEFAULTS = {
  ...COMMON_EDGE_DEFAULTS,

  // Additional edge fill colors for components like EquidistantChannel
  edgeFill2: "#250B98",

  // Additional edge fill for components like FibonacciRetracement
  nsEdgeFill: "#000000",
};
